import {
  theDomWatcher,
  handleNewsletterSubscribed,
  trackNewsletterSignup,
  initProductDescriptions,
} from "@theme/helpers";

import "@theme/search";

const featureLoaders = [
  {
    label: "cart",
    selectors: ["[data-cart-drawer]", "[data-cart-container]", "[data-open-cart]"],
    observe: true,
    loader: () => import("@theme/cart"),
  },
  {
    label: "wishlist",
    selectors: ["[wishlist-button]", "[wishlist-grid]", "[side-cart-wishlist-grid]"],
    observe: true,
    loader: () => import("@theme/wishlist"),
  },
  {
    label: "side-cart-tabs",
    selectors: ['.side-cart-tabs[role="tablist"]', "[data-cart-tab]"],
    observe: true,
    loader: () => import("@theme/tabs"),
  },
  {
    label: "toasty",
    selectors: ["body"],
    loader: () => import("@theme/toasty"),
  },
  {
    label: "product-quick-add",
    selectors: ["[product-quick-add]", "product-form"],
    observe: true,
    loader: () =>
      import("@theme/product-quick-add").then(({ ProductQuickAdd }) => new ProductQuickAdd()),
  },
  {
    label: "quickview",
    selectors: ["product-quick-view", "quickview-modal"],
    loader: () => import("@theme/quickview").then(({ ProductQuickView }) => new ProductQuickView()),
  },
  {
    label: "product-form",
    selectors: ["product-form"],
    observe: true,
    loader: () => import("@theme/option-selectors").then(({ ProductForm }) => new ProductForm()),
  },
  {
    label: "product-card",
    selectors: ["product-card"],
    loader: () => import("@theme/product-card").then(({ ProductCard }) => new ProductCard()),
  },
  {
    label: "predictive-search",
    selectors: ["predictive-search"],
    loader: () => import("@theme/search").then(({ SearchController }) => new SearchController()),
  },
  {
    label: "menu",
    selectors: ["#open-mobile-menu", ".mobile-menu-outer-wrapper"],
    loader: () => import("@theme/menu").then(({ MenuController }) => new MenuController()),
  },
  {
    label: "accordion",
    selectors: [".accordion"],
    loader: () =>
      import("@theme/accordion").then(({ AccordionController }) => new AccordionController()),
  },
  {
    label: "product-quantity",
    selectors: ["[quantity-select]"],
    observe: true,
    loader: () =>
      import("@theme/product-quantity").then(({ ProductQuantity }) => new ProductQuantity()),
  },
  {
    label: "complementary-products-swiper",
    selectors: ["[data-complementary-swiper]"],
    observe: true,
    loader: () => import("@theme/complementary-products-swiper"),
  },
  {
    label: "header-scroll",
    selectors: [".header-outer-shopify-wrapper"],
    loader: () =>
      import("@theme/header-scroll").then(
        ({ HeaderScrollController }) => new HeaderScrollController(),
      ),
  },
  {
    label: "modal-controller",
    selectors: ["[data-modal-trigger]", "[data-modal]"],
    loader: () =>
      import("@theme/modal-controller").then(({ ModalController }) => new ModalController()),
  },
  {
    label: "store-locator",
    selectors: ["[data-store-locator]", "[data-store-locator-drawer]"],
    observe: true,
    loader: () =>
      import("@theme/store-locator").then(({ initStoreLocator, initStoreLocatorDrawer }) => {
        if (typeof initStoreLocator === "function") initStoreLocator();
        if (typeof initStoreLocatorDrawer === "function") initStoreLocatorDrawer();
      }),
  },
  {
    label: "catalogue-filters",
    selectors: ["[data-filter-controls]"],
    observe: true,
    loader: () =>
      import("@theme/catalogue-filters").then(({ CatalogueFilters }) => new CatalogueFilters()),
  },
];

featureLoaders.forEach(({ selectors, loader, label, observe }) =>
  theDomWatcher(selectors, loader, { label, observe }),
);

theDomWatcher(["swiper-container", ".swiper"], () => import("@theme/swiper"), {
  label: "swiper",
  observe: true,
});

theDomWatcher(
  "swiper-container[navigation]",
  () =>
    import("@theme/swiper-accessibility").then(({ initSwiperAccessibility }) =>
      initSwiperAccessibility(),
    ),
  { label: "swiper-accessibility", observe: true },
);

theDomWatcher("form.newsletter-form", handleNewsletterSubscribed, { label: "newsletter-form" });
theDomWatcher('input[name="contact[email]"]', trackNewsletterSignup, {
  label: "newsletter-signup",
});
theDomWatcher("[read-more-container]", initProductDescriptions, { label: "read-more" });
